import React, { useRef, useEffect, useCallback } from "react";

export default function ActivityHandler({ children }) {
  const timeoutTracker = useRef(null);
  const timeToInactivity = 1800000; // 30 mins to consider inactive

  const handleInactivity = useCallback(() => {
    window.location = "/api/sign-out";
  }, []);

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutTracker.current);
    timeoutTracker.current = setTimeout(handleInactivity, timeToInactivity);
  }, [handleInactivity]);

  useEffect(() => {
    timeoutTracker.current = setTimeout(handleInactivity, timeToInactivity);

    window.addEventListener("mousedown", resetTimer);
    window.addEventListener("keypress", resetTimer);

    return () => {
      clearTimeout(timeoutTracker.current);
      window.removeEventListener("mousedown", resetTimer);
      window.removeEventListener("keypress", resetTimer);
    };
  }, [resetTimer, handleInactivity]);

  return children;
}
